import React from "react";

import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";

import { SelectField, withNamespace } from "components/Form/FormikControls";
import { SelectFieldOption } from "components/Form/FormikControls/types";
import { Tooltip } from "components/Form/FormikControls/Tooltip";
import { Paper } from "components/Paper";
import { MediumText as Heading } from "components/Text";

import { getExportSiteOptionsByConsignmentId } from "selectors";

interface VisibilitySectionProps {
  consignmentId: string;
  namespace?: string;
  readOnly?: boolean;
}

export const VisibilitySection = ({
  consignmentId,
  namespace,
  readOnly,
}: VisibilitySectionProps): React.JSX.Element => {
  const exportSiteOptions: SelectFieldOption[] =
    useSelector(getExportSiteOptionsByConsignmentId(consignmentId)) ?? [];

  return (
    <Grid item xs={12}>
      <Paper>
        <Grid container spacing={2} alignContent="center">
          <Grid item container alignItems="center" xs={9}>
            <Heading>Visibility</Heading>
          </Grid>
          <Grid item container alignItems="center" xs={1}>
            <Tooltip title="Should this listing be published on the external integration." />
          </Grid>

          <Grid item xs={12}>
            <SelectField
              isMulti
              options={exportSiteOptions}
              name={withNamespace(namespace, "exportSites")}
              label="Export To"
              disabled={readOnly}
            />
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};
